import script from "./ArchiveButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchiveButton.vue?vue&type=script&setup=true&lang=ts"

import "./ArchiveButton.vue?vue&type=style&index=0&id=6c6424c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6424c8"]])

export default __exports__